<!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
@if (!isIframe) {
<router-outlet></router-outlet>
}

<footer class="home-footer">
    @if (isHomePage && isMainSite) {
    <div class="home-footer__funding">
        <div class="home-footer__container">
            <p class="home-footer__intro">This site brought to you by <a href="https://trpa.gov">TRPA</a> with funding provided by</p>
            <div class="home-footer__logos">
                <a href="https://trpa.gov" title="Tahoe Regional Planning Agency"><img src="assets/img/funding_org_trpa.png" alt="TRPA" /></a>
                <a href="https://epa.gov" title="US Environmental Protection Agency"><img src="assets/img/funding_org_epa.png" alt="EPA" /></a>
                <a href="https://sgc.ca.gov" title="California Strategic Growth Council"><img src="assets/img/funding_org_sgc.png" alt="SGC" /></a>
                <a href="https://fs.fed.us" title="US Forest Service"><img src="assets/img/funding_org_usfs.png" alt="USFS" /></a>
            </div>
            <div class="home-footer__logos">
                <a href="https://dot.ca.gov/" title="California Department of Transportation"><img src="assets/img/funding_org_caltrans.png" alt="CALTRANS" /></a>
                <a href="https://www.fhwa.dot.gov/" title="US Federal Highway Administration"><img src="assets/img/funding_org_fhwa.png" alt="FHWA" /></a>
                <a href="https://ndep.nv.gov/" title="Nevada Division of Environmental Protection"><img src="assets/img/funding_org_ndep.png" alt="NDEP" /></a>
                <a href="https://tahoercd.org/" title="Tahoe Resource Conservation District"><img src="assets/img/funding_org_TRCD.png" alt="TRCD" /></a>
            </div>
            <p class="home-footer__partnership">In partnership with</p>
            <div class="home-footer__logos home-footer__logos--partners">
                <a href="https://esassoc.com/services/technology/" title="Environmental Science Associates"><img src="assets/img/built_by_esa.png" alt="Environmental Science Associates" /></a>
                <a href="https://enviroincentives.com/" title="Environmental Incentives"><img src="assets/img/built_by_ei.png" alt="Environmental Incentives" /></a>
            </div>
        </div>
    </div>
    }
    <div class="home-footer__content">
        <p class="home-footer__credit">
            <strong>Implementation &amp; Hosting by <a href="https://esassoc.com/services/technology/">Environmental Science Associates</a></strong>
            @if (isEip) {
                <br /><br />
                <strong>
                    The EIP Project Tracker is a <a href="/">Lake Tahoe Info</a> site sponsored by <a href="https://www.trpa.gov">TRPA</a> &amp;
                    <a href="http://tahoempo.org/">TMPO</a> and created by
                    <a href="https://esassoc.com/services/technology/">Environmental Science Associates</a>
                </strong>
            }
        </p>
        @if (isParcelTracker) {
            <p class="home-footer__disclaimer">
                <strong>Disclaimer:</strong> The information provided in this application has been compiled by Tahoe Regional Planning Agency (TRPA)
                from a variety of sources and is subject to change without notice. TRPA makes no representations or warranties, express or implied,
                as to accuracy, completeness, timeliness, or rights to the use of such information. This application is not intended for use as a
                survey product or to generate legal documentation. TRPA shall not be liable for any general, special, indirect, incidental, or
                consequential damages including, but not limited to, lost revenues or lost profits resulting from the use or misuse of the information
                gathered through the use of this application. Any sale of products or information generated through the use of this application is
                prohibited except by written permission of TRPA. Project-level verifications of land capability, existing and potential coverage,
                and/or units of use shall be required for any projects. This information is provided for reference only. TRPA approval of any
                non-exempt activities, projects or transfers is required.
            </p>
        }
        <p class="home-footer__disclaimer">
            Portions of the Lake Tahoe Info platform may be freely modified and redistributed. The open source version of the
            EIP Project Tracker is available as <a href="https://projectfirma.com">ProjectFirma</a> on <a href="https://github.com/sitkatech/projectfirma">GitHub</a>. The source code for the Stormwater Tools is available upon request.
            Other components of LT Info are available via commercial licensing through the Tahoe Regional Planning Agency (<a href="mailto:trpa@trpa.gov">trpa&#64;trpa.gov</a>).
        </p>
        <img src="assets/img/trpa-logo-footer.png" alt="TRPA" />
        <p class="home-footer__copyright">
            Copyright (C) {{ currentYear }} <a href="https://trpa.gov">Tahoe Regional Planning Agency</a>
        </p>
    </div>
</footer>

<app-alert-display></app-alert-display>
